import { PageHeader } from "@/Components/Header/PageHeader";
import UiButton from "@/UI-Components/Buttons/UiButton";
import UiTable from "@/UI-Components/Tables/UiTable";
import UiPageWrapper from "@/UI-Components/Wrapper/UiPageWrapper";
import { Plus, Upload } from "lucide-react";
import useIfscMaster from "./hooks/useIfscMaster";

const IfscMasterPage = () => {
  const {
    services: { getAllIfscService },
    states: { ifscQuery, setIfscQuery },
  } = useIfscMaster();

  return (
    <UiPageWrapper className=" flex flex-col gap-6 bg-white w-full h-screen">
      <PageHeader
        leftContent={
          <div className="flex flex-col">
            <h1 className="text-lg font-semibold text-primary -mb-1">
              IFSC Master
            </h1>
            <span className="text-sm text-wrap ">
              Master to keep track of all the IFSC.
            </span>
          </div>
        }
      />
      <div className="px-4">
        <UiTable
          dataSet={getAllIfscService || []}
          columnsSchema={[]}
          actionButtonComponent={
            <>
              <UiButton
                text={"Add IFSC"}
                className="px-4 !h-8 w-32 flex flex-row-reverse"
                icon={<Plus className="size-4" />}
              />
              <UiButton
                text={"Upload Excel"}
                className="px-4 !h-8 w-36 flex flex-row-reverse"
                icon={<Upload className="size-4" />}
              />
              <UiButton
                text={"Export"}
                className="px-4 !h-8 w-24"
                icon={<></>}
              />
            </>
          }
          maxHeightClassName="max-h-[calc(100vh-280px)] "
          query={ifscQuery}
          setQuery={setIfscQuery}
        />
      </div>
    </UiPageWrapper>
  );
};

export default IfscMasterPage;
